/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApplicationFeatureFunctionalityDto } from '../models';
// @ts-ignore
import type { CreateApplicationFeatureFunctionalitiesDto } from '../models';
/**
 * ApplicationFeatureFunctionalityApi - axios parameter creator
 * @export
 */
export const ApplicationFeatureFunctionalityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateApplicationFeatureFunctionalitiesDto} createApplicationFeatureFunctionalitiesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationFeatureFunctionalityControllerCreateApplicationFeatureFunctionalities: async (createApplicationFeatureFunctionalitiesDto: CreateApplicationFeatureFunctionalitiesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createApplicationFeatureFunctionalitiesDto' is not null or undefined
            assertParamExists('applicationFeatureFunctionalityControllerCreateApplicationFeatureFunctionalities', 'createApplicationFeatureFunctionalitiesDto', createApplicationFeatureFunctionalitiesDto)
            const localVarPath = `/api/application-feature-functionality`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createApplicationFeatureFunctionalitiesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationFeatureFunctionalityControllerGetApplicationFeatureFunctionalities: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/application-feature-functionality`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<ApplicationFeatureFunctionalityDto>} applicationFeatureFunctionalityDto Array of application feature functionalities to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationFeatureFunctionalityControllerUpdateApplicationFeatureFunctionalities: async (applicationFeatureFunctionalityDto: Array<ApplicationFeatureFunctionalityDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'applicationFeatureFunctionalityDto' is not null or undefined
            assertParamExists('applicationFeatureFunctionalityControllerUpdateApplicationFeatureFunctionalities', 'applicationFeatureFunctionalityDto', applicationFeatureFunctionalityDto)
            const localVarPath = `/api/application-feature-functionality`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applicationFeatureFunctionalityDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApplicationFeatureFunctionalityApi - functional programming interface
 * @export
 */
export const ApplicationFeatureFunctionalityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApplicationFeatureFunctionalityApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateApplicationFeatureFunctionalitiesDto} createApplicationFeatureFunctionalitiesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applicationFeatureFunctionalityControllerCreateApplicationFeatureFunctionalities(createApplicationFeatureFunctionalitiesDto: CreateApplicationFeatureFunctionalitiesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applicationFeatureFunctionalityControllerCreateApplicationFeatureFunctionalities(createApplicationFeatureFunctionalitiesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicationFeatureFunctionalityApi.applicationFeatureFunctionalityControllerCreateApplicationFeatureFunctionalities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applicationFeatureFunctionalityControllerGetApplicationFeatureFunctionalities(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApplicationFeatureFunctionalityDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applicationFeatureFunctionalityControllerGetApplicationFeatureFunctionalities(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicationFeatureFunctionalityApi.applicationFeatureFunctionalityControllerGetApplicationFeatureFunctionalities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<ApplicationFeatureFunctionalityDto>} applicationFeatureFunctionalityDto Array of application feature functionalities to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applicationFeatureFunctionalityControllerUpdateApplicationFeatureFunctionalities(applicationFeatureFunctionalityDto: Array<ApplicationFeatureFunctionalityDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applicationFeatureFunctionalityControllerUpdateApplicationFeatureFunctionalities(applicationFeatureFunctionalityDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicationFeatureFunctionalityApi.applicationFeatureFunctionalityControllerUpdateApplicationFeatureFunctionalities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ApplicationFeatureFunctionalityApi - factory interface
 * @export
 */
export const ApplicationFeatureFunctionalityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApplicationFeatureFunctionalityApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateApplicationFeatureFunctionalitiesDto} createApplicationFeatureFunctionalitiesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationFeatureFunctionalityControllerCreateApplicationFeatureFunctionalities(createApplicationFeatureFunctionalitiesDto: CreateApplicationFeatureFunctionalitiesDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.applicationFeatureFunctionalityControllerCreateApplicationFeatureFunctionalities(createApplicationFeatureFunctionalitiesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationFeatureFunctionalityControllerGetApplicationFeatureFunctionalities(options?: RawAxiosRequestConfig): AxiosPromise<Array<ApplicationFeatureFunctionalityDto>> {
            return localVarFp.applicationFeatureFunctionalityControllerGetApplicationFeatureFunctionalities(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<ApplicationFeatureFunctionalityDto>} applicationFeatureFunctionalityDto Array of application feature functionalities to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationFeatureFunctionalityControllerUpdateApplicationFeatureFunctionalities(applicationFeatureFunctionalityDto: Array<ApplicationFeatureFunctionalityDto>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.applicationFeatureFunctionalityControllerUpdateApplicationFeatureFunctionalities(applicationFeatureFunctionalityDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApplicationFeatureFunctionalityApi - object-oriented interface
 * @export
 * @class ApplicationFeatureFunctionalityApi
 * @extends {BaseAPI}
 */
export class ApplicationFeatureFunctionalityApi extends BaseAPI {
    /**
     * 
     * @param {CreateApplicationFeatureFunctionalitiesDto} createApplicationFeatureFunctionalitiesDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationFeatureFunctionalityApi
     */
    public applicationFeatureFunctionalityControllerCreateApplicationFeatureFunctionalities(createApplicationFeatureFunctionalitiesDto: CreateApplicationFeatureFunctionalitiesDto, options?: RawAxiosRequestConfig) {
        return ApplicationFeatureFunctionalityApiFp(this.configuration).applicationFeatureFunctionalityControllerCreateApplicationFeatureFunctionalities(createApplicationFeatureFunctionalitiesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationFeatureFunctionalityApi
     */
    public applicationFeatureFunctionalityControllerGetApplicationFeatureFunctionalities(options?: RawAxiosRequestConfig) {
        return ApplicationFeatureFunctionalityApiFp(this.configuration).applicationFeatureFunctionalityControllerGetApplicationFeatureFunctionalities(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<ApplicationFeatureFunctionalityDto>} applicationFeatureFunctionalityDto Array of application feature functionalities to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationFeatureFunctionalityApi
     */
    public applicationFeatureFunctionalityControllerUpdateApplicationFeatureFunctionalities(applicationFeatureFunctionalityDto: Array<ApplicationFeatureFunctionalityDto>, options?: RawAxiosRequestConfig) {
        return ApplicationFeatureFunctionalityApiFp(this.configuration).applicationFeatureFunctionalityControllerUpdateApplicationFeatureFunctionalities(applicationFeatureFunctionalityDto, options).then((request) => request(this.axios, this.basePath));
    }
}

